<template>
  <a
    :href="`/ratings/${seminar.seminarDateHash}`"
    :class="{ disabled: !seminar.seminarDateHash }"
    class="col-4 room"
    @click="(e) => checkLink(e, seminar.seminarDateHash)"
  >
    <div
      class="course-box"
      :class="{
        'bg-danger bg-opacity-25': !seminar.seminarDateHash && !loadingHashes,
        'text-muted': loadingHashes,
      }"
    >
      <span
        class="course-box__title course-title"
        :class="{ 'text-muted': loadingHashes }"
        :style="[
          !seminar.seminarDateHash && !loadingHashes
            ? { color: '#842029' }
            : null,
        ]"
      >
        <div
          class="spinner-border spinner-border-sm"
          role="status"
          v-if="loadingHashes"
          style="margin-right: 0.5em"
        >
          <span class="visually-hidden">{{ $t("common.loading") }}...</span>
        </div>
        {{ seminar.seminarTitle }}
        <span v-if="seminar.seminarType === 'Inhouseschulung beim Kunden'">
          ({{ $t("common.external") }} {{ seminar.seminarDuration
          }}{{ $t("common.unitDayAdj") }})</span
        >
      </span>
      <ul class="course-box__meta">
        <li>
          <font-awesome-icon
            icon="fa-graduation-cap"
            class="icon-color"
            aria-hidden="true"
          />
          <span class="course-trainer ct-style">
            {{ seminar.trainerName }}</span
          >
        </li>
        <li>
          <font-awesome-icon
            icon="fa-location-dot"
            class="icon-color"
            aria-hidden="true"
          />
          <span class="course-room cr-style">
            {{ $t("common.room") }}: {{ seminar.roomName || "E" }}</span
          >
        </li>
        <li>
          <font-awesome-icon
            icon="fa-regular fa-clock"
            class="icon-color"
            aria-hidden="true"
          />
          <span class="course-duration cd-style">
            {{ seminar.seminarDuration }}
            {{
              seminar.seminarDuration > 1
                ? $t("common.unitDayPl")
                : $t("common.unitDay")
            }}</span
          >
        </li>
      </ul>
    </div>
  </a>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Room",
  props: {
    seminar: Object,
    loadingHashes: Boolean,
  },
  computed: {
    ...mapGetters(["seminarHashes"]),
  },
  methods: {
    ...mapActions(["fetchHashes"]),
    checkLink(e, seminarDateHash) {
      if (!seminarDateHash) {
        e.preventDefault();
      }
    },
  },
};
</script>

<style scoped></style>
